import React from 'react'
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { usePostBrandMutation } from '../../../../store/api/barand_master';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1.jsx";
import { useLazyGetStockAccountsByCompanyQuery,useLazyGetParentWarehousesQuery ,useGetCompanyListQuery, useGetParentWarehousesQuery, useCreateWarehouseMutation } from '../../../../store/api/warehousemaster';

function Createwarehouse() {
  const navigate = useNavigate()
  const [tab, settab] = useState(1)
  const [res, setRes] = useState(false)
  const [brand, setBrand] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [postBrand] = usePostBrandMutation();
  const [parentcompany, setparentcompany] = useState([]);
  const [fullcompanylist, setfullcompanylist] = useState([]);
  const [accounts, setaccounts] = useState([]);


const [triggerGetParentWarehouses] = useLazyGetParentWarehousesQuery();
  const { data: companyList, isLoading: isCompanyLoading } = useGetCompanyListQuery();
  console.log(companyList, "companyList");

  const { data: parent_company, isLoading: isParentWHLoading, isError } = useGetParentWarehousesQuery();

  useEffect(() => {
    if (companyList) {
      setfullcompanylist(companyList)
    }
  }, [parent_company]);


  const [formData, setFormData] = useState({
    warehouseName: '',
    parentWarehouse: '',
    company: '',
    account: '',
    abbr: '',
    phoneNo: '',
    mobileNo: '',
    addressLine1: '',
    addressLine2: '',
    county: '',
    stateProvince: '',
    cityTown: '',
    postalCode: '',
    isGroupWarehouse: true,
    isRejectedWarehouse: false
  });

  const handleInputChange = (fieldName, value) => {
    console.log(fieldName, value, "fieldName, value");
    if (["company"].includes(fieldName)) {
      handleSpecialFieldChange(fieldName, value);
    }
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const [triggerGetStockAccounts] = useLazyGetStockAccountsByCompanyQuery();

  const handleSpecialFieldChange = (fieldName, value) => {
    console.log(`Special field changed: ${fieldName} -> ${value}`);

    if (fieldName === "company") {
      triggerGetStockAccounts(value)
        .unwrap()
        .then((data) => {
          console.log("Stock accounts for company:", data);
          setaccounts(data)

        })
        .catch((error) => {
          console.error("Error fetching stock accounts:", error);
        });
    }
    if (fieldName === "company") {
    triggerGetParentWarehouses(value)
      .unwrap()
      .then((data) => {
        console.log("Parent warehouses for company:", data);
        setparentcompany(data);
      })
      .catch((error) => {
        console.error("Error fetching parent warehouses:", error);
      });
  }
  }
  const [createWarehouse, { data, isLoading: loadingWHCreate, isError: isErrorCreatingWH }] = useCreateWarehouseMutation();

  const handleSubmit = async () => {
    // Required fields list
    const requiredFields = [
      { key: "warehouseName", label: "Warehouse Name" },
      { key: "company", label: "Company" },
      { key: "account", label: "Account" },
      { key: "abbr", label: "Abbreviation" },

    ];

    for (let field of requiredFields) {
      if (!formData[field.key] || formData[field.key].trim() === "") {
        setError(`${field.label} is required`);
        setptype("Error");
        setShowError(true);
        return;
      }
    }
    if (!formData.company) {
      setError('Company is required');
      setptype('Error');
      setShowError(true);
      return;
    }
    if (!formData.account) {
      setError('Account is required');
      setptype('Error');
      setShowError(true);
      return;
    }
    if (!formData.abbr.trim()) {
      setError('Abbreviation is required');
      setptype('Error');
      setShowError(true);
      return;
    }
    if (!formData.phoneNo.trim()) {
      setError('Phone Number is required');
      setptype('Error');
      setShowError(true);
      return;
    }
    if (!formData.addressLine1.trim()) {
      setError('Address Line 1 is required');
      setptype('Error');
      setShowError(true);
      return;
    }
    if (!formData.cityTown.trim()) {
      setError('City/Town is required');
      setptype('Error');
      setShowError(true);
      return;
    }
    if (!formData.stateProvince.trim()) {
      setError('State/Province is required');
      setptype('Error');
      setShowError(true);
      return;
    }
    if (!formData.postalCode.trim()) {
      setError('Postal Code is required');
      setptype('Error');
      setShowError(true);
      return;
    }

    try {
      const payload = {
        warehouse_name: formData.warehouseName,
        parent_warehouse: "",
        company: formData.company,
        account: formData.account,
        custom_abbr: formData.abbr,
        phone_no: formData.phoneNo,
        mobile_no: formData.mobileNo,
        address_line_1: formData.addressLine1,
        address_line_2: formData.addressLine2,
        custom_country: formData.county,
        state: formData.stateProvince,
        city: formData.cityTown,
        pin: formData.postalCode,
        is_group: true,
        is_rejected_warehouse: formData.isRejectedWarehouse || false,
      };

      console.log("Submitting payload:", payload);
      await createWarehouse(payload);

      setError("Warehouse created successfully!");
      setptype("Success");
      setShowError(true);
      setTimeout(() => {
        navigate("/master/warehouse-list");
      }, 3000);

    } catch (err) {
      setError(err?.data?.message || "Failed to create warehouse");
      setptype("Error");
      setShowError(true);
    }
  };


  return (
    <>
      <FormLayout
        title="New Warehouse"
        breadcrumbs={[
          { label: "Master" },
          { label: "Warehouse List ", url: "/master/warehouse-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>

            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: '2px', height: '28px' }}
              onClick={handleSubmit}
              iconSize={12}
            >
              save
            </Button>

            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
              <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                <span style={{ position: 'relative', top: '-1px' }}>
                  <GetIcon iconName="CgAttachment" size={12} />
                </span>
                <span className=" fw-semibold" style={{ color: "#391F84" }}>
                  Attachments
                </span>
              </div>
            </div>
          </div>
          <div className="mt-2 py-2" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
            <div className="row d-flex justify-content-between">
              <div className="col-12" >
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                    parentcompany={parentcompany}
                    fullcompanylist={companyList}
                    accounts={accounts}
                    formData={formData}
                    onInputChange={handleInputChange}

                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayout>
    </>
  )
}

export default Createwarehouse
